import { createSelector } from 'reselect';

import ProjectsSelectors from './projects.selectors';

const selectAllPackages = state => state.packages.items || [];

const selectPackageById = packageId => createSelector(
  selectAllPackages,
  packages => packages.find(packageDoc => packageDoc?._id === packageId) || {},
);

const selectPackageByProjectId = projectId => createSelector(
  ProjectsSelectors.selectProjectById(projectId),
  selectAllPackages,
  (project, packages) => packages.find(packageDoc => packageDoc?._id === project.packageId) || {},
);
const selectPackageByProjectIdV2 = createSelector(
  (state, projectId) => ProjectsSelectors.selectProjectByIdV2(state, projectId),
  selectAllPackages,
  (project, packages) => packages.find(packageDoc => packageDoc?._id === project.packageId) || {},
);


const selectPackageByUserRoleAndId = (userRole, userId) => createSelector(
  ProjectsSelectors.selectProjectByUserRoleAndId(userRole, userId),
  selectAllPackages,
  (project, packages) => packages.find(packageDoc => packageDoc?._id === project.packageId) || {},
);

const selectNotCustomPackages = createSelector(
  selectAllPackages,
  packages => packages.filter(packageDoc => !packageDoc.isCustom) || [],
);

const selectRequestStatus = state => state.packages.status;

const selectPackage = state => state.packages.items[0] || {};

export default {
  selectAllPackages,
  selectPackageById,
  selectPackageByProjectId,
  selectPackageByProjectIdV2,
  selectPackageByUserRoleAndId,
  selectNotCustomPackages,
  selectRequestStatus,
  selectPackage,
};
